<ion-content class="bg-color ion-content update-org">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>

        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <form [formGroup]="updateOrgform" (ngSubmit)="onSubmit()">
          <mat-card>
            <mat-card-title class="mc-title">
              <span class="mat-title-header">Organization</span>
            </mat-card-title>
            <mat-card-content class="mc-content">
              <div class="form-container">

                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>First name</mat-label>
                      <input type="text" formControlName="firstName" matInput placeholder="First name" (keydown.enter)="$event.preventDefault()" required>
                      <!-- <mat-error *ngIf="submitted && f.firstName.hasError('required')">First Name Required. </mat-error> -->
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Last name</mat-label>
                      <input type="text" formControlName="lastName" matInput placeholder="Last name" (keydown.enter)="$event.preventDefault()" required>
                      <!-- <mat-error *ngIf="submitted && f.lastName.hasError('required')">Last Name Required. </mat-error> -->
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Work email</mat-label>
                      <input type="text" formControlName="email" matInput placeholder="Work email Address" (keydown.enter)="$event.preventDefault()" required readonly>
                      <!-- <mat-error *ngIf="submitted && f.email.hasError('required')">Work email Required. </mat-error> -->
                      <!-- <mat-error *ngIf="submitted && f.email.hasError('email')">Email must be Valid. </mat-error> -->
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Phone number</mat-label>
                      <!-- <span matPrefix>+91 &nbsp;&nbsp;</span> -->
                      <input type="text" minlength="10" maxlength="18" formControlName="phone" matInput placeholder="Phone number" (keydown.enter)="$event.preventDefault()" required>
                      <!-- <mat-error *ngIf="submitted && f.phone.hasError('required')">Phone number Required. </mat-error> -->

                      <!-- <mat-error *ngIf="updateOrgform.get('phone').hasError('pattern')">
                        Please Enter a Valid Phone Number
                      </mat-error> -->
                      <mat-error *ngIf="updateOrgform.get('phone').hasError('required')">
                        Phone Number is Required!
                      </mat-error>
                      <mat-error *ngIf="updateOrgform.get('phone').hasError('minlength')">
                        <!-- Minimum length should be 10 digits -->
                        Please Enter a Valid 10 digit Phone Number
                      </mat-error>
                      <mat-error *ngIf="updateOrgform.get('phone').hasError('maxlength')">
                        Maximum length should be 18 digits
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Job Title</mat-label>
                      <mat-select formControlName="jobTitle" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let job of jobTitle" value="{{job.name}}">{{job.name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="submitted && f.jobTitle.hasError('required')">Job Title Required. </mat-error> -->
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Employee</mat-label>
                      <mat-select formControlName="employee" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let emp of employee" value="{{emp.name}}">{{emp.name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="submitted && f.employee.hasError('required')">Employee Required. </mat-error> -->
                    </mat-form-field>
                  </div>
                  <div class="form-layout">
                    <mat-form-field appearance="outline">
                      <mat-label>Company</mat-label>
                      <input type="text" formControlName="company" matInput placeholder="Company" (keydown.enter)="$event.preventDefault()" required>
                      <!-- <mat-error *ngIf="submitted && f.company.hasError('required')">Company Required. </mat-error> -->
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Country</mat-label>
                      <mat-select formControlName="country" required>
                        <mat-option>-- Select --</mat-option>
                        <mat-option *ngFor="let country of countries" value="{{country.country_name}}">{{country.country_name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="submitted && f.country.hasError('required')">Country Required. </mat-error> -->
                    </mat-form-field>
                  </div>

                  <div class="form-layout" *ngIf="orgObj?.free_trial_mode == 0">
                    <mat-form-field appearance="outline">
                      <mat-label>Subscription Start date</mat-label>
                      <input matInput [matDatepicker]="picker1" formControlName="subscriptionStartDate" (keydown.enter)="$event.preventDefault()" readonly>
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1 disabled="true"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Subscription End date</mat-label>
                      <input matInput [matDatepicker]="picker2" formControlName="subscriptionEndDate" (keydown.enter)="$event.preventDefault()">
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  </div>

                  <div class="form-layout">

                    <mat-form-field appearance="outline">
                      <mat-label>Company Address</mat-label>
                      <textarea matInput rows="5" cols="40" formControlName="company_address" placeholder="Company Address" (keydown.enter)="$event.preventDefault()"></textarea>
                    </mat-form-field>
                  </div>

                  <div class="form-layout">
                    <div class="logo-layout">
                      <div class="logo">
                        <img [src]="imagePath">
                        <mat-icon *ngIf="isEnableCompanyLogoChanges" class="clear-image" (click)="clearCompanyLogo()">highlight_off</mat-icon>
                      </div>
                      <div class="file-upload">
                        <input type="file" #companyLogo (change)="uploadCompanyLogo($event)" accept="image/x-png,image/jpeg" (keydown.enter)="$event.preventDefault()">
                      </div>
                      <p style="color: #ff0000; padding: 10px 0;">Upload file format of jpg, jpeg and png only upto size of 100KB</p>
                    </div>
                  </div>
                  <!-- <div class="links-grid">
                    <mat-checkbox formControlName="agreeSubscription" required>I agree to the  <a style="text-decoration: none;" class="signin-link" href="javascript:void(0)">Master Subscription Agreement</a></mat-checkbox>
                    <mat-error *ngIf="submitted && f.agreeSubscription.hasError('required')">Please accept Master subscription. </mat-error>
                    <p>By registering you confirm that agree to stroring and processing of your personal data by Bizdata as described in the privacy statement</p>
                  </div> -->

              </div>
            </mat-card-content>
          </mat-card>

          <mat-card class="margin-top-10">
            <mat-card-title class="mc-title">
              <h4 class="mat-title-header">Additional Information</h4>
            </mat-card-title>
            <mat-card-content class="mc-content">
              <div class="form-container">
                <div class="list-info">
                  <span>Create by</span>
                  <span>{{orgObj?.first_name}} {{orgObj?.last_name}}</span>
                </div>
                <div class="list-info">
                  <span>Updated by</span>
                  <span>{{orgObj?.updated_by}}</span>
                </div>
                <div class="list-info">
                  <span>Create date</span>
                  <span>{{orgObj?.created_date | date: 'medium'}}</span>
                </div>
                <div class="list-info">
                  <span>Update date</span>
                  <span>{{orgObj?.updated_date | date: 'medium'}}</span>
                </div>
                <div class="list-info">
                  <span>Create IP address</span>
                  <span>{{orgObj?.create_ip_address}}</span>
                </div>
                <div class="list-info">
                  <span>Updated IP address</span>
                  <span>{{orgObj?.update_ip_address}}</span>
                </div>
                <div class="btn-signup-grid">
                  <button mat-raised-button class="btn" routerLink="/baseapp/organization">Cancel</button>
                  <button mat-raised-button type="submit" class="btn btn-signup">Update</button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>
